import React, { Component } from 'react';
import axios from "axios";
import InputMask from 'react-input-mask';

import api from '../../../api/';

import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';


import Informe from "./Informe.js"
import Avanzar from "./Avanzar.js"
import AvanzarInformeCliente from "./AvanzarInformeCliente.js"
import PosponerVencLinkInforme from './PosponerVencMail';
import ParadigmaTable from "../../../components/ParadigmaTable/"
import DateFilter from "../../../components/ParadigmaTable/DateFilter";

import Enums from "../EstadoEnum.js"

import dateFunctions from '../../functions/dateFunctions';

class CargaInforme extends Component {
    constructor() {
        super();
        this.state = {
            startDate: null,
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.codigo.toUpperCase()),
                    show: true,
                },
                {
                    Header: "cantEtapas",
                    id: "cantEtapas",
                    accessor: "cantEtapas",
                    show: false,
                    private:true,
                },
                {
                    Header: "Etapa",
                    id: "numeroEtapa",
                    width: 50,
                    accessor: (d)=> (d.numeroEtapa && d.cantEtapas) ? ((d.cantEtapas!=0) ? (d.numeroEtapa + '/' + d.cantEtapas) : ('-')) : ('-'),
                    show: true,
                    className: "text-center",
                },
                {
                    Header: "Código Interno",
                    id: "codigo",
                    accessor: "codigo",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fechaEstado",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaEstado),
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Fecha Informe",
                    id: "fechainforme",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechainforme),
                    show: false,
                    private:true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Título",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Empresa/Organización",
                    id: "empresa_nombre",
                    accessor: d => d.empresa_nombre,
                    show: true,
                },
                {
                    Header: "Usuario",
                    id: "fullname",
                    accessor: d => d.fullname,
                    show: true,
                },
                {
                    Header: "Informe",
                    id: "urlinforme",
                    filterable: false,
                    className: "text-center",
                    accessor: d => d.urlinforme,
                    show: true,
                    Cell: props => (props.value != '' ? <a target={"_blank"} href={props.value}>DESCARGAR</a> : <div className="badge badge-danger">NO EMITE</div>),
                    width: 100,
                },
                {
                    Header: "Estado",
                    id: "strestado",
                    width: 200,
                    show: true,
                    className: "text-center",
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="CARGANDO INFORME">CARGANDO INFORME</option>
                            <option value="INFORME CARGADO">INFORME CARGADO</option>
                            <option value="SIN INFORME">SIN INFORME</option>
                        </select>,
                    accessor: d => {
                        if (d.strestado == "CARGANDO INFORME")
                        return (<div className="badge badge-warning presupuestoStateLabel">{d.strestado}
                        <br></br> <small>{dateFunctions.parseDateTime(d.fechainforme)}</small>
                        </div>);
                        else if (d.strestado == "INFORME CARGADO")
                            return (<div className="badge badge-success presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechainforme)}</small>
                            </div>);
                        else
                        return (<div className="badge badge-primary presupuestoStateLabel">{d.strestado}
                        <br></br> <small>{dateFunctions.parseDateTime(d.fechainforme)}</small>
                        </div>);
                    },
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        edit: true,
                        permission: 'informes_edit',
                        component: Informe,
                    },
                    {
                        edit: true,
                        permission: 'informes_edit',
                        component: PosponerVencLinkInforme,
                    },
                    {
                        edit: true,
                        permission: 'informes_next',
                        component: Avanzar,
                    },
                    {
                        edit: true,
                        permission: 'informes_next',
                        component: AvanzarInformeCliente,
                    },
                ]}

                apiUrl={api.proyectos.informes.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.informes.export}
                title={"Informes"}
            />
        );
    }
}

export default CargaInforme;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento4/CargaInforme.js